export const translations = {
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  novaLinha: {
    pt: 'Novo negócio',
    en: 'New business',
    de: 'Neues Geschäft',
    es: 'Nuevo negocio',
  },
};
